/* global $:true */

import React, { Component } from 'react';

class AboutBlock extends Component {
    componentDidMount() {
        $('#quote-carousel').carousel({
            pause: true,
            interval: 5000
        });
    }

    render() {
        return (
            <div className="simple-col-wrapper index-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 left-col">
                            <h2>About</h2>
                            <p>
                                The Clever Tykes storybooks and teaching resources inspire <strong>positivity, creativity and resourcefulness</strong> in children ages 6-9. They introduce important life skills and characteristics through positive, entrepreneurial role models.
                            </p>
                            <br />
                            <p>
                                The stories follow three separate protagonists as they each realise that there is something they are especially good at or passionate about, and they set about making this into their own venture.
                            </p>
                            <br />
                            <p>
                                The resources include three storybooks and accompanying teacher’s guides and lesson plans. Perfect for PSHE.
                            </p>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <h2>Enterprise for all</h2>

                            <div className="carousel slide" data-ride="carousel" id="quote-carousel">
                                <ol className="carousel-indicators">
                                    <li data-target="#quote-carousel" data-slide-to="0" className="active" />
                                    <li data-target="#quote-carousel" data-slide-to="1" />
                                    <li data-target="#quote-carousel" data-slide-to="2" />
                                    <li data-target="#quote-carousel" data-slide-to="3" />
                                </ol>
                                <div className="carousel-inner">

                                    <div className="item active">
                                        <blockquote>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <p>
                                                        It’s a wonderful concept and the series has been delivered with teaching in mind. We have
                                                        used the books for year 4 and 5 and the kids really get a lot out of the text. They provide
                                                        a great resource for discussion points and exercises for PSHE and beyond.
                                                    </p>
                                                    <small>Richard Parslow – Interim headteacher, Birmingham</small>
                                                </div>
                                            </div>
                                        </blockquote>
                                    </div>

                                    <div className="item">
                                        <blockquote>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <p>
                                                        The children in Year 5 at Deykin Avenue thoroughly enjoyed reading Walk-it Willow. They
                                                        were able to relate to the characters in the story and they have asked if they can write
                                                        their own stories based around Willow. The children were so enthused that they wanted to
                                                        read the story over and over again. They have also asked if they can take the book home.
                                                    </p>
                                                    <small>Janet Edwards – Headteacher & Pamela Gayle – Literacy Co-Ordinator, Birmingham</small>
                                                </div>
                                            </div>
                                        </blockquote>
                                    </div>

                                    <div className="item">
                                        <blockquote>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <p>
                                                        I read Walk-it Willow to 30 pupils in year 5 who who were delighted by the hilarious
                                                        opening scene of a dog attempting to escape from the obligatory bath-time.
                                                        <br /><br />
                                                        I would highly recommend it to teachers looking for material for PSHE lessons-the topics
                                                        and themes addressed in the book would make for constructive and weighty conversation for
                                                        the whole class.
                                                    </p>
                                                    <small>Sarah Graham-Watson, Year 5 teacher, Maidenhead</small>
                                                </div>
                                            </div>
                                        </blockquote>
                                    </div>

                                    <div className="item">
                                        <blockquote>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <p>
                                                        Reading is a priority for the school and Walk-it Willow has engaged all of the children,
                                                        even those that are sometimes reluctant readers. The book generated a lot of discussion
                                                        points and in particular gave the children opportunities to use the ideas in their own
                                                        writing.
                                                    </p>
                                                    <small>Janet Edwards – Headteacher & Pamela Gayle – Literacy Co-Ordinator, Birmingham</small>
                                                </div>
                                            </div>
                                        </blockquote>
                                    </div>

                                </div>
                                <a data-slide="prev" href="#quote-carousel" className="left carousel-control"><i className="fa fa-chevron-left" /></a>
                                <a data-slide="next" href="#quote-carousel" className="right carousel-control"><i className="fa fa-chevron-right" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutBlock;



/** WEBPACK FOOTER **
 ** ./src/components/AboutBlock.js
 **/